module.exports = __webpack_public_path__ + "static/media/tick-circle-gray.7e3e8a81.svg";